var system = {};
module['exports'] = system;
system.mimeTypes = require("./mimeTypes");


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/system/index.js
// module id = 1084
// module chunks = 0